const categoryDescriptionList = {
    
        NEWS: "Here you can find out all latest news and get your self upto date with all other things",
        SPORTS: "Here you can find out all latest sports and get your self upto date with all other things",
        CRIME: "Here you can find out all latest crime and get your self upto date with all other things",
        ENTERTAINMENT: "Here you can find out all latest entertainment and get your self upto date with all other things",
        Liferay: "Liferay Updates",
        NextJS: "",
        FutureTrends: "",
        TechTutorials: "",
        GenAI: "Generative AI",
        Shopify: "Shopify"
};


export default categoryDescriptionList;